<template>
  <div class="container pt-100 pb-70">
    <div class="row justify-content-center">
      <div class="col-xl-4 col-md-6">
        <div
          class="home_one-pricing-card bg-magnolia round-10 br-one mb-30 position-relative transition"
        >
          <h6 class="fs-20 text-title">Business</h6>
          <h2>
            $638
            <span class="fs-15 fw-normal f-primary position-relative text-para">
              /Monthly
            </span>
          </h2>
          <p class="mb-0 br-two">
            State burst think end are its. Arrived off she elderly beloved him.
          </p>
          <ul class="pricing-features list-style">
            <li class="checked text-title fw-medium">
              <img src="../../assets/img/icons/check.svg" alt="Image" />30 Days
              Money Back Guarantee
            </li>
            <li class="checked text-title fw-medium">
              <img src="../../assets/img/icons/check.svg" alt="Image" />More
              customization options
            </li>
            <li class="checked text-title fw-medium">
              <img src="../../assets/img/icons/check.svg" alt="Image" />Priority
              customer support
            </li>
            <li class="unchecked text-title fw-medium">
              <img src="../../assets/img/icons/close.svg" alt="Image" />No
              advertisements or branding
            </li>
            <li class="unchecked text-title fw-medium">
              <img src="../../assets/img/icons/close.svg" alt="Image" />
              Unlimited customer support
            </li>
          </ul>
          <router-link to="/register" class="btn style-three">
            Get Started Now
          </router-link>
        </div>
      </div>
      <div class="col-xl-4 col-md-6">
        <div
          class="home_one-pricing-card featured bg-magnolia round-10 br-one mb-30 position-relative transition"
        >
          <span
            class="featured-tag fs-15 text-white position-absolute end-0 d-inline-block lh-1"
          >
            Popular
          </span>
          <h6 class="fs-20 text-title">
            Personal
            <span class="lh-1 rounded-1 position-relative d-inline-block">
              25% Off
            </span>
          </h6>
          <h2>
            $838
            <span class="fs-15 fw-normal f-primary position-relative text-para">
              /Monthly
            </span>
          </h2>
          <p class="mb-0 br-two">
            State burst think end are its. Arrived off she elderly beloved him.
          </p>
          <ul class="pricing-features list-style">
            <li class="checked text-title fw-medium">
              <img src="../../assets/img/icons/check.svg" alt="Image" />30 Days
              Money Back Guarantee
            </li>
            <li class="checked text-title fw-medium">
              <img src="../../assets/img/icons/check.svg" alt="Image" />More
              customization options
            </li>
            <li class="checked text-title fw-medium">
              <img src="../../assets/img/icons/check.svg" alt="Image" />Priority
              customer support
            </li>
            <li class="checked text-title fw-medium">
              <img src="../../assets/img/icons/check.svg" alt="Image" />No
              advertisements or branding
            </li>
            <li class="unchecked text-title fw-medium">
              <img src="../../assets/img/icons/close.svg" alt="Image" />
              Unlimited customer support
            </li>
          </ul>
          <router-link to="/register" class="btn style-three">
            Get Started Now
          </router-link>
        </div>
      </div>
      <div class="col-xl-4 col-md-6">
        <div
          class="home_one-pricing-card bg-magnolia round-10 br-one mb-30 position-relative transition"
        >
          <h6 class="fs-20 text-title">Premium</h6>
          <h2>
            $638
            <span class="fs-15 fw-normal f-primary position-relative text-para">
              /Monthly
            </span>
          </h2>
          <p class="mb-0 br-two">
            State burst think end are its. Arrived off she elderly beloved him.
          </p>
          <ul class="pricing-features list-style">
            <li class="checked text-title fw-medium">
              <img src="../../assets/img/icons/check.svg" alt="Image" />30 Days
              Money Back Guarantee
            </li>
            <li class="checked text-title fw-medium">
              <img src="../../assets/img/icons/check.svg" alt="Image" />More
              customization options
            </li>
            <li class="checked text-title fw-medium">
              <img src="../../assets/img/icons/check.svg" alt="Image" />Priority
              customer support
            </li>
            <li class="checked text-title fw-medium">
              <img src="../../assets/img/icons/check.svg" alt="Image" />No
              advertisements or branding
            </li>
            <li class="checked text-title fw-medium">
              <img src="../../assets/img/icons/check.svg" alt="Image" />
              Unlimited customer support
            </li>
          </ul>
          <router-link to="/register" class="btn style-three">
            Get Started Now
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PricingPlan",
};
</script>

<style lang="scss" scoped>
.home_one-pricing-card {
  padding: 45px 25px 50px;
  z-index: 1;
  overflow: hidden;
  &:after {
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    width: 0%;
    height: 100%;
    background-image: url(../../assets/img/home-one/pricing-bg.webp);
    background-position: top center;
    background-size: cover;
    background-repeat: no-repeat;
    background-color: transparent;
    z-index: -1;
    visibility: hidden;
    opacity: 0;
    transition: var(--transition);
  }
  h6 {
    font-weight: 500;
    line-height: 28px;
    margin: 0;
    span {
      background: var(--whiteColor);
      padding: 5.5px 11.5px;
      top: -4px;
      margin-left: 8px;
      font-size: 12px;
      letter-spacing: -0.3px;
      color: var(--optionalColor);
    }
  }
  h2 {
    color: var(--bruntColor);
    font-size: 54px;
    font-weight: 700;
    line-height: 52px;
    margin: 32px 0 3px;
    span {
      margin-left: 2px;
      top: -1px;
    }
  }
  p {
    padding-bottom: 26px;
  }
  .featured-tag {
    background-image: url(../../assets/img/home-one/feature-tag-bg.webp);
    background-position: left center;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: transparent;
    padding: 5.5px 22px 7.5px 28px;
    font-weight: 300;
    top: 55px;
  }
  .pricing-features {
    padding: 32px 0 40px;
    li {
      position: relative;
      margin-bottom: 24.5px;
      font-weight: 500;
      padding-left: 28px;
      letter-spacing: 0.012px;
      &:last-child {
        margin-bottom: 0;
      }
      img {
        position: absolute;
        top: 4.5px;
        left: 0;
      }
    }
  }
  &.active,
  &:hover {
    .btn {
      &:before {
        width: 100%;
        background: linear-gradient(92deg, #a861f9 0%, #8145d4 100%);
        z-index: -1;
      }
      border-color: transparent;
      color: var(--whiteColor);
    }
    &:after {
      width: 100%;
      visibility: visible;
      opacity: 1;
    }
  }
}

@media only screen and (max-width: 767px) {
  .home_one-pricing-card {
    padding: 30px 22px 35px;
    h2 {
      font-size: 48px;
      line-height: 55px;
    }
    p {
      padding-bottom: 26px;
    }
    .featured-tag {
      top: 35px;
    }
    .pricing-features {
      padding: 25px 0 34px;
      li {
        font-size: 14px;
        line-height: 25px;
        margin-bottom: 18px;
        img {
          top: 2.5px;
          max-width: 15px;
        }
      }
    }
  }
}
@media only screen and (min-width: 1400px) {
  .home_one-pricing-card {
    padding: 45px 50px 50px;
  }
}
</style>